<template>
    <div id="ContactView" class="ContactView ssection">
        <div>
            <p class="h2-shadow">CONTACT ME</p>
            <h2>CONTACT ME</h2>
            <div class="progress-row">
                <p class="text-center">Do you want to work on a new or existing project with me? Feel free to reach out to
                me on any social platforms</p>
            </div>
            <div class="center-box">
                <div class="progress-row">
                    <div class="portfolio-box">
                        <div class="iconc">
                            <img src="../assets/contact/icon_github.svg" alt class="icon-fluid" />
                            <a href="https://github.com/NesaByte" target="_blank">
                                <p>GitHub</p>
                            </a>
                        </div>
                    </div>
                    <div class="portfolio-box">
                        <div class="iconc">
                            <img src="../assets/contact/icon_wordpress.svg" alt class="icon-fluid" />
                            <a href="https://nesabyte.wordpress.com/" target="_blank">
                                <p>Wordpress</p>
                            </a>
                        </div>
                    </div>
                    <div class="portfolio-box">
                        <div class="iconc">
                            <img src="../assets/contact/icon_discord.svg" alt class="icon-fluid" />
                            <a href="https://discord.gg/UcKhTFRDSD" target="_blank">
                                <p>Discord</p>
                            </a>
                        </div>
                    </div>
                    <div class="portfolio-box">
                        <div class="iconc">
                            <img src="../assets/contact/icon_address.svg" alt class="icon-fluid" />
                            <p>Ontario, Canada</p>
                        </div>
                    </div>
                    <div class="portfolio-box">
                        <div class="iconc">
                            <img src="../assets/contact/icon_email.svg" alt class="icon-fluid" />
                            <p>nesabyte@gmail.com</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
export default {
    name: 'ContactView',
}
</script>
  
<style>
.text-center {
    text-align: center;
    color: #39170F;

}

.ContactView {
    background-size: cover;
    display: block;
    width: 100%;
    height: auto;
    background-repeat: no-repeat;
    background-position: center;
    background-color: #FFFCF4;
}

.progress-row {
    display: block;
    margin-top: 5%;
    margin-bottom: 5%;
    padding: 0% 10%;
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;
    width: 100%;
    height: auto;
}

.iconc p {
    margin-top: 0%;
    text-align: center;
    color: #c17a00;
    font-size: 16px;
}

.icon-fluid {
    max-width: 100%;
    max-height: 100%;
}

.iconc {
    position: relative;
    vertical-align: middle;
    border-style: none;
    margin: 0px 10px 0px 10px;
}

.portfolio-box {
    box-sizing: border-box;
    display: block;
    max-width: 20%;
    flex-basis: 20%;
    /*border: yellow solid; 
    max-width: 14.2857143%;
    flex-basis: 14.2857143%;*/
    flex-grow: 0;
    flex-shrink: 0;
    font-size: 16px;
    line-height: 24px;
    width: 240px;
}

@media screen and (max-width: 1024px) {
    .portfolio-box {
        max-width: 25%;
        flex-basis: 25%;
    }

    .progress-row {
        padding: 0% 25%;
    }
}

@media screen and (max-width: 768px) {
    .portfolio-box {
        max-width: 33%;
        flex-basis: 33%;
    }

    .progress-row {
        padding: 0% 20%;
    }

    .iconc p {
        font-size: 12px;
    }
}

@media screen and (max-width: 650px) {
    .portfolio-box {
        max-width: 33%;
        flex-basis: 33%;
    }

    .progress-row {
        padding: 0% 15%;
    }

    .iconc p {
        font-size: 12px;
    }
}

@media screen and (max-width: 400px) {
    .portfolio-box {
        max-width: 50%;
        flex-basis: 50%;
    }

    .progress-row {
        padding: 0% 15%;
    }

    .iconc p {
        font-size: 10px;
    }
}
</style>
  